'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var Skeleton = require('@material-ui/core/Skeleton');
var renderCell = require('./utils/renderCell.js');
var useDataTable = require('./useDataTable.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Skeleton__default = /*#__PURE__*/_interopDefaultLegacy(Skeleton);

var Cell = /*#__PURE__*/React__default['default'].memo(_ref => {
  var {
    width,
    rowIndex,
    columnIndex,
    value,
    row
  } = _ref;
  var {
    customRenderers,
    columns
  } = useDataTable.useDataTable();
  var {
    type,
    align
  } = columns[columnIndex];
  var cellContent = value === undefined ? /*#__PURE__*/React__default['default'].createElement(Skeleton__default['default'], {
    variant: "text"
  }) : /*#__PURE__*/React__default['default'].createElement("span", null, customRenderers !== null && customRenderers !== void 0 && customRenderers[type] ? customRenderers[type](rowIndex, row) : renderCell.renderCell(type, value));
  return /*#__PURE__*/React__default['default'].createElement("div", {
    role: "cell",
    className: "GenjoDataTable__cell",
    style: {
      textAlign: align,
      width: width,
      maxWidth: width,
      minWidth: width
    }
  }, cellContent);
});
Cell.propTypes = {
  columnIndex: index.number,
  rowIndex: index.number,
  style: index.object,
  data: index.object
};
Cell.displayName = 'Cell';

exports.Cell = Cell;
exports.default = Cell;
